import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../context/app/appContext';

const ActiveUsers = () => {
    const [activeUsers, setActiveUsers] = useState(0)

    const appContext = useContext(AppContext);

    useEffect(() => {
        loadActiveEmployees()
    }, [appContext.employees])
    const loadActiveEmployees = () => {
        setActiveUsers(appContext.employees.filter(emp => {return emp.status !== undefined && emp.status === 'active'}).length)
        // appContext.employees.map((employee) =>
        //     employee.status === 'active' ? setActiveUsers((prevstate) => prevstate + 1) : null)
    }

    return (
        <div style={{ height: '120px', width: '100%', textAlign: 'center', paddingTop: '20px', display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{fontSize: 20, fontStyle: 'SFProText-Bold', color: 'rgba(0, 207, 143, 1)', flex: 1}}>Active Users</div>
            {/* <div style={{fontSize: 40, fontStyle: 'SFProText-Bold', color: 'rgba(0, 207, 143, 1)', flex: 1}}>{activeUsers}</div> */}
            <div style={{fontSize: 40, fontStyle: 'SFProText-Bold', color: 'rgba(0, 207, 143, 1)', flex: 1}}>64</div>
        </div>
    )

}
export default ActiveUsers